import * as React from 'react';
import { Fragment } from 'react';
import { observer } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import Translate from './Translate';
import Document from './Document';
import Disclaimers from './Disclaimers';
import { computed } from 'mobx';

const LiteratureWrapper = styled<any, any>('div')`
    ${propStyles};
`;

LiteratureWrapper.defaultProps = {
    paddingX: ['md', 'xl'],
    paddingY: 'md',
    borderWidth: '1px',
    borderColor: 'gray300',
    borderStyle: ['none', 'solid none none none'],
};

const LiteratureHeading = styled<any, any>('h2')`
    ${propStyles};
`;

LiteratureHeading.defaultProps = {
    display: ['none', 'block'],
    marginX: 'sm',
    marginY: 'sm',
    fontFamily: 'heading',
    fontWeight: 'medium',
    fontSize: 'sm',
};

const DocumentCategoryHeading = styled<any, any>('h2')`
    ${propStyles};
`;

DocumentCategoryHeading.defaultProps = {
    display: 'block',
    marginX: 'sm',
    marginY: 'sm',
    fontFamily: 'heading',
    fontWeight: 'medium',
    fontSize: 'sm',
};

const DocumentsList = styled<any, any>('ul')`
    ${propStyles};
`;

DocumentsList.defaultProps = {
    display: 'flex',
    flexDirection: ['column', 'row'],
    flexWrap: 'wrap',
};

const DocumentCategoryWrapper = styled<any, any>('div')`
    ${propStyles};
`;
DocumentCategoryWrapper.defaultProps = {
    display: 'flex',
    flexDirection: ['column', 'row'],
};

const DocumentCategoryList = styled<any, any>('ul')`
    ${propStyles};
`;

DocumentCategoryList.defaultProps = {
    // display: 'flex',
    // flexWrap: 'wrap',
};

const DocumentCategory = styled<any, any>('div')`
    ${propStyles};
`;

DocumentCategory.defaultProps = {
    width: '100%',
};

class FundDocuments extends React.Component<any, any> {
    @computed
    get hasDocumentCategories() {
        const { documentCategories } = this.props;
        return documentCategories !== undefined;
    }

    @computed
    get groupedDocuments() {
        const {
            theme,
            groupedDocuments,
            documentDownloads,
            toggleDownload,
            documentSelected,
            selectedDocumentsLabel,
            availableDocumentsLabel,
            documentTypeAliases,
        } = this.props;
        return (
            <Fragment>
                <LiteratureHeading {...theme.LiteratureHeading}>
                    <Translate>Fund Literature</Translate>
                </LiteratureHeading>
                <DocumentsList {...theme.DocumentsList}>
                    {groupedDocuments.map((documentGroup, index) => (
                        <Document
                            key={index}
                            index={index}
                            documentGroupName={documentGroup.documentGroupName}
                            documents={documentGroup.documents}
                            documentDownloads={documentDownloads}
                            toggleDownload={toggleDownload}
                            documentSelected={documentSelected}
                            selectedDocumentsLabel={selectedDocumentsLabel}
                            availableDocumentsLabel={availableDocumentsLabel}
                            documentTypeAliases={documentTypeAliases}
                        />
                    ))}
                </DocumentsList>
            </Fragment>
        );
    }

    @computed
    get categoryDocuments() {
        const {
            theme,
            documentDownloads,
            toggleDownload,
            documentSelected,
            selectedDocumentsLabel,
            availableDocumentsLabel,
            documentCategories,
            documentTypeAliases,
        } = this.props;
        return (
            <DocumentCategoryWrapper {...theme.DocumentCategoryWrapper}>
                {documentCategories.map(documentCategory => {
                    return (
                        <DocumentCategory
                            key={documentCategory.heading}
                            {...theme.DocumentCategory}
                        >
                            <DocumentCategoryHeading
                                {...theme.DocumentCategoryHeading}
                            >
                                <Translate>
                                    {documentCategory.heading}
                                </Translate>
                            </DocumentCategoryHeading>
                            <DocumentCategoryList
                                {...theme.DocumentCategoryList}
                            >
                                {Object.keys(
                                    documentCategory.groupedDocuments
                                ).map((key, index) => {
                                    const groupedDocuments =
                                        documentCategory.groupedDocuments[key];
                                    return (
                                        <Document
                                            key={index}
                                            documentGroupName={
                                                groupedDocuments.documentGroupName
                                            }
                                            documents={
                                                groupedDocuments.documents
                                            }
                                            documentDownloads={
                                                documentDownloads
                                            }
                                            toggleDownload={toggleDownload}
                                            documentSelected={documentSelected}
                                            selectedDocumentsLabel={
                                                selectedDocumentsLabel
                                            }
                                            availableDocumentsLabel={
                                                availableDocumentsLabel
                                            }
                                            documentTypeAliases={
                                                documentTypeAliases
                                            }
                                        />
                                    );
                                })}
                            </DocumentCategoryList>
                        </DocumentCategory>
                    );
                })}
            </DocumentCategoryWrapper>
        );
    }

    render() {
        const {
            theme,
            groupedDocuments,
            fundCardDisclaimers,
            noDocumentsDisclaimers,
        } = this.props;
        return (
            <LiteratureWrapper {...theme.LiteratureWrapper}>
                {groupedDocuments.length === 0 ? (
                    <Disclaimers
                        disclaimers={noDocumentsDisclaimers}
                        theme={{
                            ...theme,
                            DisclaimersList: theme.NoDocumentsDisclaimersList,
                            DisclaimerListItem: {
                                justifyContent: 'center',
                                ...theme.NoDocumentsDisclaimerListItem,
                            },
                            DisclaimerContent: {
                                paddingX: 'md',
                                paddingY: 'md',
                                fontFamily: 'heading',
                                fontWeight: 'medium',
                                fontSize: 'sm',
                                ...theme.NoDocumentsDisclaimerContent,
                            },
                        }}
                    />
                ) : this.hasDocumentCategories ? (
                    this.categoryDocuments
                ) : (
                    this.groupedDocuments
                )}
                <Disclaimers
                    disclaimers={fundCardDisclaimers}
                    theme={{
                        ...theme,
                        DisclaimersList: theme.DocumentsDisclaimersList,
                        DisclaimerListItem: theme.DocumentsDisclaimerListItem,
                        DisclaimerContent: theme.DocumentsDisclaimerContent,
                    }}
                />
            </LiteratureWrapper>
        );
    }
}

export default withTheme(observer(FundDocuments)) as any;



// WEBPACK FOOTER //
// ./src/Components/FundDocuments.tsx